import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { StyledTabs } from "components/StyledTabs";
import type { CodesKind } from "shared/constants";

export interface CodesKindToggleProps {
  value: CodesKind;
  onChange: (kind: CodesKind) => void;
  focusOnMount?: boolean;
}

/** Fills its parent's height, so the parent sets the size. */
export const CodesKindToggle = ({
  value,
  onChange,
  focusOnMount,
}: CodesKindToggleProps) => {
  const { t } = useTranslation(["components"]);
  const containerRef = useRef<HTMLDivElement>(null);

  // On the Codes page the toggle sits in each scheme's search row, so switching remounts it and would drop keyboard focus.
  useEffect(() => {
    if (focusOnMount) {
      containerRef.current
        ?.querySelector<HTMLElement>('[role="tab"][aria-selected="true"]')
        ?.focus();
    }
  }, [focusOnMount]);

  return (
    <div ref={containerRef} className="h-full">
      <StyledTabs<CodesKind>
        activeTab={value}
        onTabChange={onChange}
        variant="segmented"
        className="h-full"
        tabs={[
          { value: "THEMA", label: t("components:codesKindToggle.thema") },
          { value: "BISAC", label: t("components:codesKindToggle.bisac") },
        ]}
      />
    </div>
  );
};
